<template>
    <b-overlay :show="historytableLoading" rounded="sm">
    <div class="bg-white p-3">
        <b-row>
            <b-col cols="12" class="d-flex">
                <!-- <b-button-group> -->
                <strong class="me-auto align-self-center">{{ $translate("page") }}: {{ currentPage }} {{ $translate("of") }}
                    {{ Math.ceil(historyrows / itemsPerPage) }} {{ $translate("total") }}:
                    {{ historyrows }}</strong>
                <b-button variant="blue-button" class="me-2" @click="shouldShowFilters = !shouldShowFilters">
                    <span style="white-space: nowrap">
                        {{ $translate('filters') }}
                        <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                            }`"></b-icon>
                    </span>
                </b-button>
                <b-button class="me-2" @click="exportInvoiceButton">
                    Excel
                </b-button>
                <b-button variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                    :title="$translate('reset_filters')">
                    <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                </b-button>
                <!-- </b-button-group> -->
            </b-col>
            <b-col class="text-right mb-2" cols="4">
                <slot></slot>
            </b-col>
        </b-row>
        <HistoryItemsQueryFilter class="mt-3" v-show="shouldShowFilters" :officer-option="officerOption"
            :locations="locations" :itemTypes="itemTypes" :orderTypes="orderTypes" :officers="users" ref="queryFilter" v-model="filters"
            :disabled-officers="!hasPermissionView" />
        <!-- <p class="mt-3"> -->
        <div class="mt-3">
            <!-- </p> -->
            <b-table id="historytabledata" v-model="historytabledata" :per-page="historyitemsPerPage" :current-page="currentPage" :fields="fields" :filters="filters"
                striped hover ref="table" responsive :items="historyItems" class="mt-3">
                <template #cell(location_section)="{ item }">
                    <div v-html="getInventoryLocation(item)"></div>
                </template>

                <template #cell(item_type)="{ item }">
                    <div>
                        {{
                            item.item_type?.name
                        }}
                    </div>
                </template>

                <template #cell(activity_type)="{ item }">
                    <div>
                        {{
                            (
                                orderTypes.find(
                                    x => item.order.order_type_id == x.id
                                ) || {}
                            ).name
                        }}
                    </div>
                </template>
                <template #cell(customer)="{ item }">
                    <div>
                        {{ item.customer_id ? `${item?.customer?.name} [${item?.customer?.code}]` :'' }}
                    </div>
                </template>
                <template #cell(activity)="{ item }">
                    <div>
                        <b-link :to="`/ams/activities/${item.order.id}`">
                            {{ item.order.reference_no }}</b-link>
                    </div>
                </template>
            </b-table>
            <b-row>
                <b-col class="d-flex justify-content-center mt-4">
                    <b-pagination class="float-right" v-model="currentPage" :total-rows="historyrows"
                        :per-page="historyitemsPerPage" :next-text="$translate('next')" :prev-text="$translate('previous')"
                        aria-controls="roleTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <portal-target name="history"></portal-target>
    </div>
    </b-overlay>
</template>

<script>
import XLSX from 'xlsx'
import _ from 'lodash'
import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import HistoryItemsQueryFilter from './HistoryItemsQueryFilter.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
import showItemHelper from '@/mixins/showItemHelper'
import importMixins from '@/mixins/importMixins'

const defaultModel = Object.freeze({
    created_start: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    created_end: moment().format('YYYY-MM-DD'),
})
const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}
export default {
    name: 'inventoryTransfer-HistoryListItems',
    components: { HistoryItemsQueryFilter },
    props: ['type', 'title', 'item'],
    // mixins: [popupMixins, permissionsMixins],
    mixins: [popupMixins, permissionsMixins, showItemHelper, importMixins],

    data() {
        return {
            query: '',
            model: { ...defaultModel },
            historytableLoading: false,
            historytabledata: [],
            selectedFromDate: '',
            selectedProductId: '',
            selectedToDate: '',
            itemsPerPage: 15,
            historyitemsPerPage: 15,
            currentPage: 1,
            shouldShowFilters: false,
            filters: {
                product_search: null,
                location_id: null,
                order_item_type_id: [],
                item_type_id: [],
                officer_id: null,
                fromDate: defaultModel.created_start,
                toDate: defaultModel.created_end,
                include_customer: false,
                qty_sum_by_customer: false,
            },
        }
    },
    async mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        await this.doSearch()
    },
    watch: {
        dateRange: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.model.created_start = moment()
                        .subtract(30, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment().format('YYYY-MM-DD')
                    break
                case dateRangeEnum.yesterday:
                    this.model.created_start = moment()
                        .subtract(31, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    break
                default:
                    break
            }
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        'filters.include_customer': {
            handler: function(include_customer){
                const CustomerLabel = "Customer";
                const { fields } = this;

                const customerField = {
                    key: "customer",
                    label: this.$translate("customer"),
                };
                const idx = fields.findIndex((x) => x.key === customerField.key);
                if (idx == -1 && include_customer === true) {
                    this.addField(CustomerLabel, customerField, 4)
                }else if(!include_customer){
                    this.deleteField(idx)
                }
            }
        },
        'filters.qty_sum_by_customer': {
            handler: function(qty_sum_by_customer){
                const ActivityLabel = this.$translate("activity");
                const ActivityTypeLabel = this.$translate("activity_type");
                const { fields } = this;

                const activityTypeField = {
                    key: "activity_type",
                    label: this.$translate("activity_type"),
                };
                const activityField = {
                    key: "activity",
                    label: this.$translate("activity"),
                };
                
                const activityTypeIdx = fields.findIndex((x) => x.key === activityField.key);
                const activityIdx = fields.findIndex((x) => x.key === activityTypeField.key);
                if (qty_sum_by_customer === false) {
                    this.addField(ActivityLabel, activityField, 8)
                    this.addField(ActivityTypeLabel, activityTypeField, 7)
                }else if(qty_sum_by_customer){
                    this.deleteField(activityTypeIdx)
                    this.deleteField(activityIdx)
                }
            }
        },
        query: _.debounce(function (query) {
            //console.log("query:", query)
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),

        report_loading: function (val) {
            this.$emit('report-state', val)
        },

        historyItems: {
            handler: function () {
                // this.historytableLoading = false
            },
        },
    },
    computed: {
        // historyitemFields() {
        //     return [
        //         {
        //             key: 'item Code',
        //             label: this.$translate('item_code'),
        //             formatter: (value, key, item) => item.ext_reference_code,
        //         },
        //         {
        //             key: 'updated_at',
        //             label: this.$translate('transaction_date'),
        //             formatter: value =>
        //                 !value ? '' : this.formatDateTime(value), // tk: To be revisited
        //         },
        //         {
        //             key: 'Product Name',
        //             label: this.$translate('product_name'),
        //             formatter: (value, key, item) => item.name,
        //         },

        //         {
        //             key: 'Item Type',
        //             label: this.$translate('item_type'),
        //             formatter: (value, key, item) => item.type.name,
        //         },
        //         {
        //             key: 'UOM',
        //             label: this.$translate('uom'),
        //             formatter: (value, key, item) => item.uom,
        //         },
        //         {
        //             key: 'From',
        //             label: this.$translate('from_warehouse_location_section_Officer'),
        //             formatter: (value, key, item) =>
        //                 `${item.sections[0] &&
        //                 item.sections[0].location_section.location.name
        //                 } /${item.sections[0] &&
        //                 item.sections[0].location_section.officers[0] &&
        //                 item.sections[0].location_section.officers[0]
        //                     .first_name
        //                 }`,
        //         },

        //         {
        //             key: 'To',
        //             label: this.$translate('to_warehouse_location_section_Officer'),
        //         },
        //         {
        //             key: 'Qty Transfer',
        //             label: this.$translate('qty_on_hand'),
        //         },

        //         {
        //             key: 'Note',
        //             label: this.$translate('note'),
        //         },
        //     ]
        // },

        fields() {
            return [
                { key: 'id', label: this.$translate('id') },
                {
                    key: 'name',
                    label: this.$translate('item_name'),
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('item_code'),
                },
                {
                    key: 'item_type',
                    label: this.$translate('item_type'),
                },
                {
                    key: 'location_section',
                    label: this.$translate('locations'),
                },
                {
                    key: 'datetime',
                    label: this.$translate('date_time'),
                    formatter: (value, key, item) =>
                        new Date(item.sortedTime).toLocaleDateString() +
                        ' ' +
                        new Date(item.sortedTime).toLocaleTimeString(),
                },
                {
                    key: 'added_amount',
                    label: this.$translate('movements'),
                },
                {
                    key: 'activity_type',
                    label: this.$translate('activity_type'),
                },
                {
                    key: 'activity',
                    label: this.$translate('activity'),
                }

                // // 'activity_type',
                // 'activity',
            ]
        },
        officerOption() {
            return '----officers----'
        },
        defaultFromDate() {
            return moment().subtract(30, 'days').toDate() // 30 days ago from today
        },
        defaultToDate() {
            return new Date() // today's date
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        itemTypes() {
            return this.$store.state.itemType.items
        },
        users() {
            return this.$store.getters['users/sorted_officers']
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse || x.sections.some(y => !y.is_officer)
            )
        },
        historyItems() {
            const historyItemsArray = this.$store.state.masterItem.historyItems
            // .flatMap(data =>
            //     data.sections.flatMap(section =>
            //         section.transactions.map(transaction => ({
            //             location_section: section.location_section,
            //             sortedTime: new Date(transaction.created_at).getTime(),
            //             quantity_on_hand: section.quantity_on_hand,
            //             ...transaction,
            //             item_type: data.type,
            //             name: data.name,
            //             ext_reference_code: data.ext_reference_code
            //         }))
            //     )
            // );
            return this.historyFilterdData(historyItemsArray);

        },
        sectionItems() {
            return this.$store.state.masterItem
        },
        historyrows() {
            const historyitemRows =
                this.historyItems.length
            return historyitemRows
        },
        products() {
            const _items = this.$store.state.masterItem.section_items
            return _items
        },
    },
    methods: {
        historyFilterdData(historydata) {
            console.log('historydata', historydata)
            //filter out non warehouses
            const {
                fromDate,
                toDate,
                location_id,
                officer_id,
                order_item_type_id,
                item_type_id,
                qty_sum_by_customer
            } = this.filters
            let data = [...(historydata || [])].filter(
                x =>
                    !x.location_section ||
                    x.location_section.is_officer ||
                    x.location_section.officers.length ||
                    x.location_section.location.is_warehouse
            )
            if (parseInt(location_id, 10)) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        x.location_section.location.id == location_id &&
                        x.location_section.location.is_warehouse &&
                        x.location_section.officers.length == 0
                )
            }

            if (location_id === this.officerOption) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        (x.location_section.is_officer ||
                            x.location_section.officers.length)
                )
            }
            if (officer_id) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        x.location_section.officers[0] &&
                        x.location_section.officers[0].id == officer_id
                )
            }
            if (order_item_type_id.length > 0) {
                data = data.filter(x => order_item_type_id.some(s => x.order.order_type_id === s.id))
            }
            if (item_type_id.length > 0) {
                data = data.filter(x => item_type_id.some(s => x.item_type.id === s.id))
            }
            if (fromDate && toDate) {
                data = data.filter(x => new Date(x.created_at) >= new Date(fromDate) && new Date(x.created_at) <= new Date(toDate))
            }
            if(qty_sum_by_customer){
                data = data.reduce((acc, cur) => {
                    // Find the group for the current customer
                    const customerGroup = acc.find(group => (group.customer?.id === cur.customer?.id && group.item_type?.id === cur.item_type?.id));

                    if (customerGroup) {
                        // If the customer group exists, check if there's a subgroup for the item_type
                        const itemTypeGroup = customerGroup.item_type.id === cur.item_type.id;

                        if (itemTypeGroup) {
                            // If the item_type subgroup exists, update its added_amount
                            customerGroup.added_amount += (cur.added_amount || 0);
                        } else {
                            // If the item_type subgroup doesn't exist, create it
                            acc.push({
                                ...cur,
                                customer_id: (cur.order.customer_id) || null,
                                customer: {...cur.customer||{}},
                                item_type: cur.item_type,
                                added_amount: cur.added_amount
                            });
                        }
                    } else {
                        // If the customer group doesn't exist, create it along with the item_type subgroup
                        acc.push({
                            ...cur,
                            customer_id: (cur.order.customer_id) || null,
                            customer: {...cur.customer||{}},
                            item_type: cur.item_type,
                            added_amount: cur.added_amount
                        });
                    }

                    return acc;
                }, []);
            }
            console.log('data--', data)
            return data
        },
        getInventoryLocation({ location_section, quantity_on_hand }, html = true) {
            // console.log('location_section', location_section)
            if (!location_section) {
                return ''
            }

            if (location_section.officers.length) {
                return (
                    (!html ? `${this.$translate('officer')}: ` : `<strong>${this.$translate('officer')}</strong>: ` 
                    ) +
                    (location_section.officers[0] &&
                        location_section.officers[0].first_name +
                        ' ' +
                        location_section.officers[0].last_name) +
                    '(' +
                    quantity_on_hand +
                    ')'
                )
            } else if (location_section.location.is_warehouse) {
                return (
                    location_section.location.name +
                    `:` +
                    location_section.name +
                    '(' +
                    quantity_on_hand +
                    ')'
                )
            } else {
                return 'Customer Location'
            }
        },
        getReportQuery() {
            return { name: this.query }
        },
        resetFilters() {
            this.filters = {
                product_search: null,
                location_id: null,
                order_item_type_id: [],
                item_type_id: [],
                officer_id: null,
                fromDate: defaultModel.created_start,
                toDate: defaultModel.created_end,
                include_customer: false,
                qty_sum_by_customer: false,
            }
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        async doSearch() {
            var {
                query,
                filters,
            } = this;
            let item_type_id = '';
            let order_item_type_id = '';
            try {
                if(filters.product_search && filters.product_search.length < 3){
                    return;
                }
                this.historytableLoading = true

                if(filters.item_type_id.length > 0){
                    item_type_id = (filters.item_type_id.map(i => i.id)).join(',')
                }
                if(filters.order_item_type_id.length > 0){
                    order_item_type_id = (filters.order_item_type_id.map(i => i.id)).join(',')
                }
                await this.$store.dispatch('masterItem/fetchHistory',{
                    query,
                    filters: {...filters, item_type_id: item_type_id, order_item_type_id: order_item_type_id},
                    
                })
            } catch (error) {
                console.log('fetchHistory Error:',error)
            } finally {
                this.historytableLoading = false
            }
        },

        exportInvoiceButton() {
            let { filters } = this;
            const invoices = this.historyItems.reduce((row, item) => { 
                if(filters.qty_sum_by_customer){
                    row.push({ 
                        name: item.name,
                        code: item.ext_reference_code,
                        type: item.item_type?.name,
                        customer: item.customer_id? `${item.customer?.name} [${item.customer?.code}]`: '',
                        location: this.getInventoryLocation(item, false),
                        date_time: new Date(item.sortedTime).toLocaleDateString() + ' ' + new Date(item.sortedTime).toLocaleTimeString(),
                        movements: item.added_amount,
                    }); 
                } else {
                    row.push({ 
                        id: item.id, 
                        name: item.name,
                        code: item.ext_reference_code,
                        type: item.item_type?.name,
                        location: this.getInventoryLocation(item, false),
                        date_time: new Date(item.sortedTime).toLocaleDateString() + ' ' + new Date(item.sortedTime).toLocaleTimeString(),
                        movements: item.added_amount,
                        activity_type: (this.orderTypes.find(x => item.order.order_type_id == x.id) || {}).name,
                        reference_no: item.order?.reference_no,
                    }); 
                }
                return row;
            }, [])
            
            var invoicesWS = XLSX.utils.json_to_sheet(invoices)
    
            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel
    
            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, invoicesWS, 'Inventory History') // invoices list is name of Worksheet
    
    
            // export Excel file
            XLSX.writeFile(wb, 'Inventory History.xlsx')
        },
        addField: function(label, field, position) {
            field.label = label;
            this.fields.splice(position, 0, field);
        },
        deleteField: function(idx) {
            this.fields.splice(idx, 1);
        },
    },
}
</script>
<style>
#historytabledata td[aria-colindex="2"]{
    white-space: wrap;
    max-width: 265px;
}
</style>
